import { z } from 'zod/v4';

export interface StepOptions extends z.TypeOf<typeof stepOptionsSchema> {}

export const stepOptionsSchema = z.object({
  value: z.number(),
  color: z.string().optional(),
  name: z.string().optional(),
  operator: z.enum(['GreaterThanOrEqual', 'Equal']).optional(),
});

export type BaseStepOptions<T extends StepOptions = StepOptions> = Omit<T, 'value'>;

export interface ThresholdOptions extends z.TypeOf<typeof thresholdOptionsSchema> {}
export const thresholdOptionsSchema = z.object({
  mode: z.enum(['Percent', 'Absolute']).optional(),
  // default color is deprecated. Should use base.color instead
  default_color: z.string().describe('deprecated').optional(),
  max: z.number().optional(),
  steps: z.array(stepOptionsSchema).optional(),
});

// Generics with Zod are tough, so I'm just building this out manually
export type GenericThresholdOptions<T extends StepOptions = StepOptions> = {
  mode?: 'Percent' | 'Absolute';
  // deprecated. Use "base" instead
  default_color?: string;
  max?: number;
  steps?: T[];
  base?: Omit<T, 'value'>;
};

export function createThresholdOptionsSchema<StepType extends z.ZodObject<typeof stepOptionsSchema.shape>>(
  stepSchema: StepType
) {
  return z.object({
    mode: z.enum(['Percent', 'Absolute']).optional(),
    max: z.number().optional(),
    steps: z.array(stepSchema).optional(),
    base: stepSchema.omit({ value: true }).optional(),
    default_color: z.string().describe('DEPRECATED: Please use base.color instead').optional(),
  });
}
